import { render, staticRenderFns } from "./CalculationResultModal.vue?vue&type=template&id=96797008&scoped=true"
import script from "./CalculationResultModal.vue?vue&type=script&lang=js"
export * from "./CalculationResultModal.vue?vue&type=script&lang=js"
import style0 from "./CalculationResultModal.vue?vue&type=style&index=0&id=96797008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96797008",
  null
  
)

export default component.exports